import get from "lodash/get";

export const RECORDING = "Recording";
export const VIDEO = "Video";
export const IMAGE = "Image";
export const SOURCE_FILE = "SourceFile";
export const TEXT = "Text";

export function isVersionUploadTypeCompatible(uploadType = "", parentType = "") {
  return Boolean(uploadType && parentType && uploadType === parentType);
}

export function getFileCategoryType(mimetype = "", fileType = "", fileName = "") {
  const normalizedFileName = String(fileName || "").toLowerCase();
  const isMarkdownFile =
    normalizedFileName.endsWith(".md") ||
    normalizedFileName.endsWith(".markdown");

  if (fileType === "_3GP" || fileType === "_3GPP") {
    return VIDEO;
  }
  if (textFileTypes.includes(fileType) || isMarkdownFile) {
    return TEXT;
  }
  if (mimetype.includes("audio")) {
    return RECORDING;
  }
  if (mimetype.includes("video")) {
    return VIDEO;
  }
  if (mimetype.includes("image")) {
    return IMAGE;
  }
  if (mimetype.includes("text")) {
    return TEXT;
  }

  return SOURCE_FILE;
}

export function isSourceFile(component) {
  const mimeType = get(component, "file[0].mimeType", "");
  const fileType = get(component, "file[0].fileType", "");
  const fileName = get(component, "file[0].fileName", "");
  return getFileCategoryType(mimeType, fileType, fileName) === SOURCE_FILE;
}

const textFileTypes = [
  "CSV",
  "DOC",
  "DOCX",
  "PAGES",
  "PDF",
  "PPT",
  "PPTX",
  "RTF",
  "TXT",
  "XLL",
  "XLS",
  "XLSX"
]
